export default "__VITE_ASSET__14169305__"